import API from './ks-engine'

const resource = 'indices';

export default {
  get (field, db, lang) {
    if (!field) {
      return API.get(`/${resource}`)
    }
    if (lang === "en") {
      return API.get(`/${resource}/${field}/${db}?lang=en`)
    } else {
      return API.get(`/${resource}/${field}/${db}`)
    }
  }
}